import { forwardRef, memo } from "react";
import classnames from "classnames";
import { DefaultEmpty } from "../icons";
import { FileTypeBase } from "../types";
import { getExtension, getMimeTypeInfo } from "../utils";

import styles from "./style.module.scss";

type FileDefaultProps = FileTypeBase

export const FileDefault = memo(forwardRef<HTMLDivElement, FileDefaultProps>((
  {
    isFolder = false,
    mimeType,
    className,
    fileExtension,
    videoIconType = "video01",
    ...props
  },
  ref
) => {
  const fileExt = getExtension(fileExtension);

  const { icon, type } = getMimeTypeInfo(mimeType, isFolder, videoIconType);

  return (
    <div
      className={classnames(className, styles.root)}
      ref={ref}
      {...props}
    >
      <DefaultEmpty />
      {fileExt ? (
        <span className={classnames(
          styles.name,
          styles[fileExt as keyof typeof styles]
        )}>
          {fileExt}
        </span>
      ) : (
        <i className={classnames(
          styles.iconMimeWrapper,
          styles[type as keyof typeof styles]
        )}>
          {icon}
        </i>
      )}
    </div>
  )
}));